import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { AppointmentsTurnsService } from 'src/app/services/turns-services/appointments-turns-service/appointment-turns.service';
import { Appointment } from 'src/app/models/turns-models/appointment.model';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-turns-appointments-dashboard',
  templateUrl: './turns-appointments-dashboard.component.html',
  styleUrls: ['./turns-appointments-dashboard.component.scss']
})
export class TurnsAppointmentsDashboardComponent implements OnInit, OnDestroy {

  appointments: Array<Appointment>;
  getDailyAppointmentsSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private appointmentsTurnsService: AppointmentsTurnsService,
              private headerBreadcrumbService: HeaderBreadcrumbService) {  }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDailyAppointments();
    this.appointmentsTurnsService.listenRefreshAppointmentsList().pipe(
      tap(res => this.appointments = res)
    ).subscribe();
  }

  private getDailyAppointments() {
    const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
    const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
    const centerInternalIdList = this.userStorageService.getCenterList().map( center => center.InternalId );
    this.getDailyAppointmentsSubscription = this.appointmentsTurnsService.getTurnsAppointments(todayFrom, todayTo, centerInternalIdList, null, null, null).subscribe(
      (res: Array<Appointment>) => {
        this.appointments = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-calendar-check', 'turns-page.appointments', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.appointments')]));
  }

  ngOnDestroy() {
    if (this.getDailyAppointmentsSubscription) { this.getDailyAppointmentsSubscription.unsubscribe(); }
  }
}
